// What a page needs the reader to notice. `Notice` is a boxed line above the
// work it is about (a warning, a failed read with its Retry); `ErrorText` is
// the bare error line under a control; `SaveStatus` is the word beside a Save
// button. Errors are always --danger, so every page's red is the same red.
const TONES = {
    error: "var(--danger)",
    warning: "var(--severity-medium)",
    info: "var(--line-strong)",
    ok: "var(--green)",
};

export default function Notice({ tone = "info", title = null, action = null, className = "", children }) {
    const color = TONES[tone] ?? TONES.info;
    return (
        <div
            role={tone === "error" ? "alert" : undefined}
            data-notice={tone}
            className={`flex flex-wrap items-start justify-between gap-x-[14px] gap-y-[8px] rounded-[8px] border px-[12px] py-[10px] text-[13px] leading-[1.45] text-[color:var(--ink)] ${className}`}
            style={{ borderColor: `color-mix(in srgb, ${color} 45%, transparent)`, background: `color-mix(in srgb, ${color} 8%, transparent)` }}
        >
            <div className="grid min-w-0 flex-1 gap-[2px]">
                {title ? <strong className="font-medium">{title}</strong> : null}
                {children ? <div className="min-w-0 text-[color:var(--muted)] [overflow-wrap:anywhere]">{children}</div> : null}
            </div>
            {action ? <div className="flex shrink-0 items-center gap-[8px]">{action}</div> : null}
        </div>
    );
}

export function ErrorText({ children, className = "" }) {
    if (!children) return null;
    return <p role="alert" className={`m-0 text-[12px] leading-[1.4] text-[color:var(--danger)] [overflow-wrap:anywhere] ${className}`}>{children}</p>;
}

// "Saving…", then the saved word for a moment, or the error. Holds its line
// while idle so the row it sits in doesn't jump.
export function SaveStatus({ status = null, error = null, savedLabel = "Saved" }) {
    if (status === "saving") return <span className="text-[12px] text-[color:var(--muted)]">Saving…</span>;
    if (status === "saved") return <span className="text-[12px] text-[color:var(--ink)]">{savedLabel}</span>;
    if (error) return <span role="alert" className="text-[12px] text-[color:var(--danger)] [overflow-wrap:anywhere]">{error}</span>;
    return <span aria-hidden="true">&nbsp;</span>;
}
